import { Link } from 'react-router-dom'

import { LogoMark } from '@/components/layout/Logo'

export default function NotFound() {
  return (
    <main className="flex min-h-dvh flex-col items-center justify-center px-6 text-center">
      <LogoMark className="size-9" />
      <p className="mt-6 text-sm font-medium text-brand-600 dark:text-brand-400">404</p>
      <h1 className="mt-2 text-2xl font-semibold tracking-tight">Page not found</h1>
      <p className="mt-1.5 max-w-sm text-sm text-ink-500 dark:text-ink-400">
        That page does not exist, or you do not have access to it.
      </p>
      <Link
        to="/"
        className="mt-6 inline-flex h-10 items-center rounded-lg bg-brand-600 px-4 text-sm font-medium text-white transition hover:bg-brand-700"
      >
        Back to Taskly
      </Link>
    </main>
  )
}
